const languageSuggestions = [
  'Afrikaans',
  'Albański',
  'Amharski',
  'Angielski',
  'Arabski',
  'Asamski',
  'Azerbejdżański',
  'Bambara',
  'Baskijski',
  'Bengalski',
  'Bhojpuri',
  'Białoruski',
  'Birmański',
  'Bislama',
  'Bodo',
  'Bośniacki',
  'Bułgarski',
  'Cebuano',
  'Chiński',
  'Chorwacki',
  'Ciluba',
  'Czeczeński',
  'Czeski',
  'Dari',
  'Diula',
  'Dogri',
  'Duński',
  'Esperanto',
  'Estoński',
  'Ewe',
  'Farsi',
  'Fidżyjski',
  'Fiński',
  'Flamandzki',
  'Francuski',
  'Fula',
  'Galicyjski',
  'Geez',
  'Grecki',
  'Gruziński',
  'Gudźarati',
  'Haitański',
  'Hausa',
  'Hebrajski',
  'Hindi',
  'Hiszpański',
  'Hmong',
  'Igbo',
  'Ilocano',
  'Indonezyjski',
  'Irlandzki',
  'Islandzki',
  'Japoński',
  'Jawajski',
  'Język wysp salomona',
  'Jidysz',
  'Joruba',
  'Kannada',
  'Kaszmirski',
  'Kataloński',
  'Kazachski',
  'Khmerski',
  'Kinyarwanda',
  'Kirgiski',
  'Konkani',
  'Koreański',
  'Kurdyjski',
  'Laotański',
  'Lingala',
  'Litewski',
  'Luksembruski',
  'Łotewski',
  'Macedoński',
  'Maithili',
  'Malajski',
  'Malayalam',
  'Malgaski',
  'Malinke',
  'Maltański',
  'Manipuri',
  'Marathi',
  'Marwari',
  'Mołdawski',
  'Mongolski',
  'Ndebele Płd.',
  'Nepalski',
  'Niderlandzki',
  'Niemiecki',
  'Niue',
  'Norweski',
  'Nyanja',
  'Orija',
  'Ormiański',
  'Oromo',
  'Pampango',
  'Pangasinan',
  'Papiamentu',
  'Paszto',
  'Pendzabski',
  'Perski',
  'Polski',
  'Portugalski',
  'Radźasthani',
  'Rosyjski',
  'Rumuński',
  'Samoański',
  'Sanskrit',
  'Santali',
  'Sardinian',
  'Sepedi',
  'Serbski',
  'Sesotho',
  'Shona',
  'Sindhi',
  'Siswati',
  'Słowacki',
  'Słoweński',
  'Sodo',
  'Suahili',
  'Sundajski',
  'Sylheti',
  'Syngaleski',
  'Szwedzki',
  'Tadżycki',
  'Tagalski',
  'Tahitański',
  'Tajski',
  'Tamilski',
  'Tatarski',
  'Telugu',
  'Tigrinia',
  'Tokelau',
  'Tonga',
  'Tsonga',
  'Tswana',
  'Turecki',
  'Turkmeński',
  'Tuvalu',
  'Tybetański',
  'Ujgurski',
  'Ukraiński',
  'Urdu',
  'Uzbecki',
  'Venda',
  'Walijski',
  'Warajski',
  'Węgierski',
  'Wietnamski',
  'Włoski',
  'Wolof',
  'Xhosa',
  'Zulu'
]

export default languageSuggestions